{
  "typeOfProperty": {
    "title": "Immobilienfinanzierung",
    "subtitle": "direkt online vergleichen",
    "question": "Was möchten Sie kaufen?",
    "apartment": "Wohnung",
    "singleFamilyHouse": "Einfamilienhaus",
    "apartmentBuilding": "Mehrfamilienhaus",
    "landPlot": "Grundstück"
  },
  "postalCode": {
    "title": "Wo liegt die Immobilie, die Sie kaufen möchten?",
    "description": "In bestimmten Gebieten bieten Banken besonders attraktive Konditionen. Mit der Angabe der Postleitzahl können wir auch diese Angebote anzeigen.",
    "label": "Postleitzahl der Immobilie",
    "placeholder": "z.B. 85774",
    "required": "Bitte geben Sie eine Postleitzahl ein",
    "invalid": "Bitte geben Sie eine gültige Postleitzahl ein"
  },
  "purchasePrice": {
    "title": "Wie hoch ist der Kaufpreis?",
    "description": "Bitte geben Sie unten den reinen Kaufpreis ohne Nebenkosten ein.",
    "label": "Kaufpreis",
    "placeholder": "z.B. 350.000",
    "required": "Bitte geben Sie den Kaufpreis ein"
  },
  "equity": {
    "title": "Wieviel Eigenkapital wollen Sie beisteuern?",
    "description": "Idealerweise sollten Sie rund 20% des Kaufpreises als Eigenkapital einbringen um eine gute Kreditrate zu erhalten. Es geht in machen Fällen auch mit weniger oder ganz ohne.",
    "label": "Einzusetzendes Eigenkapital",
    "placeholder": "z.B. 75.000",
    "required": "Bitte geben Sie ihr einzusetzendes Eigenkapital ein",
    "sellPropertyQuestion": "Planen Sie parallel auch den Verkauf einer Immobilie?"
  },
  "monthlyNetIncome": {
    "title": "Wie hoch ist Ihr monatliches Einkommen?",
    "description": "Hierbei wird das regelmäßige Haushaltsnettoeinkommen aller Haushaltsmitglieder angesetzt. Diese Information wird von den Banken (anonym) für die erste Konditionsanfrage benötigt.",
    "label": "Monatliches Haushaltsnettoeinkommen",
    "placeholder": "z.B. 4.500",
    "required": "Bitte geben Sie ihr monatliches Haushaltsnettoeinkommen ein"
  },
  "contact": {
    "title": "Letzter Schritt zum persönlichen Finanzierungsvergleich",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "email": "E-Mail",
    "phone": "Telefonnummer",
    "firstNameRequired": "Bitte geben Sie ihren Vornamen ein",
    "lastNameRequired": "Bitte geben Sie ihren Nachnamen ein",
    "emailRequired": "Bitte geben Sie ihre E-Mail Adresse ein",
    "emailInvalid": "Bitte geben Sie eine gültige E-Mail Adresse ein",
    "phoneRequired": "Bitte geben Sie ihre Telefonnummer ein",
    "phoneInvalid": "Bitte geben Sie eine gültige Telefonnummer ein",
    "error": "Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "back": "Zurück",
    "continue": "Weiter"
  },
  "offers": {
    "title": "Persönliche Finanzierungsvorschläge",
    "purchasePrice": "Kaufpreis",
    "equity": "Eigenkapital",
    "monthlyNetIncome": "Monatliches Haushaltsnettoeinkommen",
    "changeDetails": "Angaben ändern",
    "noResultsTitle": "Wir können leider keine Ergebnisse finden",
    "noResultsDescription": "Wahrscheinlich ist ihr Eigenkapitalanteil zu niedrig. Sie können auch versuchen, ihre Eingaben zu ändern, oder die Hilfe unserer Experten in Anspruch nehmen.",
    "or": "oder",
    "bookFreeConsultation": "Kostenlose Beratung buchen",
    "loadingMessage": "Wir fragen aktuelle Echtzeitkonditionen von Banken und Sparkassen an. Dies kann einen Moment dauern.",
    "reserveInterestRate": "Zins gratis reservieren",
    "discoverMoreOffers": "Mehr Angebote entdecken",
    "bookAppointment": "Termin online vereinbaren"
  },
  "interestRateModal": {
    "errorTitle": "Leider ist ein Fehler aufgetreten",
    "errorMessage": "Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "backToResults": "Zurück zu den Ergebnissen",
    "thankYouTitle": "Vielen Dank",
    "thankYouMessage": "Sie erhalten kurzfristig eine Bestätigung der Zinsreseriverung per Email zugesendet.",
    "title": "Unverbindliche Zinssicherung",
    "description": "Bei den meisten Banken können wir den Zinssatz für 2 Tage reservieren - bei einigen auch länger. Dies ist für Sie völlig kostenfrei und unverbindlich.",
    "confirmReserve": "Ja, Zinssatz reservieren"
  },
  "common": {
    "back": "Zurück",
    "continue": "Weiter",
    "step": "Schritt",
    "of": "von",
    "results": "Ergebnisse"
  }
}
